import get from 'lodash/get';

const customerTypes = {
    customer: 'Client',
    prospect: 'Prospect',
};

function formatCustomerTypes(value: string) {
    return get(customerTypes, value, value);
}

export { customerTypes, formatCustomerTypes };
